module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "adCardPage",
    attrs: {
      "id": "ada01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('h2', {
    staticClass: "adCardHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Also available from"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "ss"
  }, [_c('span', [_vm._v("CHRISTINA SKYE")])]), _c('br'), _vm._v("\nand HQN Books")])])]), _c('p', {
    staticClass: "adCardSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CODE NAME")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Code Name: Bikini")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Code Name: Blondie")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Code Name: Baby")])])])]), _c('p', {
    staticClass: "adCardSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("DRAYCOTT ABBEY")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("To Catch a Thief")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Draycott Eternal")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Draycott Legacy")])])])]), _c('p', {
    staticClass: "adCardSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("And coming in December 2009")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Bound by Dreams")])])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pageii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1732dd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/draycotteverlasting_ada01.vue
// module id = 60
// module chunks = 0